import {
  SURVEY_SOURCE_LANGUAGE,
  TRANSLATION_MODAL_MESSAGE_TRANSLATIONS,
  TRANSLATION_MODAL_MESSAGES,
} from '@constants';

/**
 * Returns a Translation Modal message in the survey source language when a curated translation
 * exists, otherwise falls back to the English source copy.
 *
 * @param {keyof typeof TRANSLATION_MODAL_MESSAGES} key
 * @param {String} language
 * @return {String}
 */
export const getTranslationModalMessage = (key, language) =>
  (language && language !== SURVEY_SOURCE_LANGUAGE
    ? TRANSLATION_MODAL_MESSAGE_TRANSLATIONS[key]?.[language]
    : undefined) ?? TRANSLATION_MODAL_MESSAGES[key];
